import { appSettings } from '../../config/settings'
import { PaymentMethodEnum } from '@ztechapps/common.contract'

/**
 * This function should configure the correct stripe settings and urls
 */
export const useStripeConfig = ({ orderId }) => {
  const createAchSourceUrl = `${appSettings.AppUrl.api}/stripe/create-ach-source`
  const success_url = `${appSettings.AppUrl.store}/checkout/success/${orderId}`
  const cancel_url = `${appSettings.AppUrl.store}/checkout/cancel/${orderId}`
  // const paymentMethods = [PaymentMethodEnum.card, PaymentMethodEnum.bankAchCredit]
  const paymentMethods = [PaymentMethodEnum.card]

  return { createAchSourceUrl, success_url, cancel_url, paymentMethods }
}
